export const mainNavsList = [
  {
    id: 0,
    title: '首页',
  },
  {
    id: 1,
    title: '前言',
  },
  {
    id: 3,
    title: '爬行动物的演化',
  },
  {
    id: 4,
    title: '具羽毛恐龙的出现',
  },
  {
    id: 5,
    title: '原始基干鸟类',
  },
  {
    id: 6,
    title: '反鸟类',
  },
  {
    id: 7,
    title: '今鸟型类',
  },
]